<template>
  <div>
    <app-gridview
      v-bind:parentData="{
        tabHeaders: this.dataHeader,
        tabItems: this.dataItems,
        pageTitle: this.pageTitle,
        search: this.search,
      }"
      v-on:EditItem="editItemHandler($event)"
      v-on:DeleteItem="deleteItemHandler($event)"
      v-on:NewPressed="newRecordHandler"
    ></app-gridview>
  </div>
</template>
<script>
// import moment from 'moment';

import GridView from "../../../components/common/GridView";

export default {
  components: {
    "app-gridview": GridView,
  },

  data() {
    return {
      pageTitle: this.$t('setuppanelclinic.panelcliniclist'),
      dataHeader: [
        { text: this.$t('columns.actions'), value: "action", sortable: false, width: "50px" },
        { text: this.$t('setuppanelclinic.cliniccode'), value: "cliniccode", width: "120px" },
        { text: this.$t('columns.description'), value: "clinicdesc", width: "200px" },
        { text: this.$t('columns.addressline1'), value: "add1", width: "200px" },
        { text: this.$t('columns.addressline2'), value: "add2", width: "200px" },
        { text: this.$t('columns.addressline3'), value: "add3", width: "200px" },
        { text: this.$t('columns.city'), value: "cityname", width: "200px" },
        { text: this.$t('columns.country'), value: "cntryname", width: "120px" },
        { text: this.$t('columns.postcode'), value: "poscode", width: "120px" },
        { text: this.$t('columns.telephone'), value: "tel", width: "200px" },
        { text: this.$t('columns.email'), value: "email", width: "200px" },
       
      ],
      dataItems: [],
      loading: false,
      errMsg: "",
      search: this.$route.params.search,
    };
  },

  methods: {
    getClinicListHandler() {
      const vm = this;

      this.loading = !this.loading;

      this.$store.dispatch('get', {url: "/clinic/all"})
        .then(function (res) {
          vm.dataItems = res.data.rec;

          vm.loading = !vm.loading;
        })
        .catch(function (err) {
          vm.errMsg = err;
        });
    },

    editItemHandler(item) {
      this.$router.push({ name: "clinicedit", params: { id: item.id, search: item.search } });
    },

    newRecordHandler() {
      this.$router.push({ name: "clinicnew" });
    },
  },
  mounted() {
    this.getClinicListHandler();
  },
};
</script>